import { useSelector } from 'react-redux';
import { isLoggedIn, isLoggingOut } from '../redux/modules/authentication';
import { hasAuthToken } from '../utilities/hasAuthToken';

export const useIsLoggedIn = () => {
  const loggedIn = useSelector(isLoggedIn);
  return loggedIn && hasAuthToken();
};

export const useIsLoggingOut = () => useSelector(isLoggingOut);
